import { LIST } from '@hotjar/webapp/constants/routes/playbacks';
import { prefetchData as prefetchDataForRecordingsList } from '@hotjar/recordings/src/features/RecordingsList/utils/prefetchData';

export const ROUTES: Array<{ path: string; prefetchData: () => void }> = [
  {
    path: LIST.path,
    prefetchData: prefetchDataForRecordingsList,
  },
];
